import "./Style/table-loader.css";

const TableLoaderIcon = () => {
    return (
        <div className="flex flex-col items-center justify-center h-[19rem]">
            <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
    )
}

export default TableLoaderIcon;